import * as stylex from '@stylexjs/stylex';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';

export const buttonStyles = stylex.create({
  base: {
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    margin: 0,
    textAlign: 'center',
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderStyle: 'solid',
    paddingLeft: '0.625rem',
    paddingRight: '0.625rem',
    borderRadius: controlMetrics.radius,
    outlineStyle: 'none',
    cursor: 'pointer',
  },
  disabled: { opacity: 0.5, cursor: 'not-allowed' },
  nativeDisabled: { pointerEvents: 'none' },
  iconLeft: { marginRight: '0.25rem' },
  iconRight: { marginLeft: '0.25rem' },
  iconColor: { color: 'inherit' },
});

export const buttonSizeStyles = stylex.create({
  xs: { fontSize: '0.75rem', lineHeight: '1rem', paddingTop: '0.125rem', paddingBottom: '0.125rem' },
  sm: { fontSize: '0.875rem', lineHeight: '1.25rem', paddingTop: '0.25rem', paddingBottom: '0.25rem' },
  lg: { fontSize: '1.25rem', lineHeight: '1.75rem', paddingTop: '0.25rem', paddingBottom: '0.25rem' },
});

export const buttonVariantStyles = stylex.create({
  'outline': {
    backgroundColor: colors.background,
    borderWidth: controlMetrics.borderWidth,
    borderColor: colors.border,
    color: colors.text,
  },
  'theme': {
    backgroundColor: colors.accent,
    borderWidth: controlMetrics.borderWidth,
    borderColor: colors.accent,
    color: colors.white,
  },
  'theme-light': {
    backgroundColor: colors.icon,
    borderWidth: controlMetrics.borderWidth,
    borderColor: colors.icon,
    color: colors.white,
  },
  'danger': {
    backgroundColor: colors.borderInvalid,
    borderWidth: controlMetrics.borderWidth,
    borderColor: colors.borderInvalid,
    color: colors.white,
  },
  'warning': {
    backgroundColor: colors.warning,
    borderWidth: controlMetrics.borderWidth,
    borderColor: colors.warning,
    color: colors.white,
  },
  'no-border': { color: colors.text },
  'navigation': { color: colors.text },
  'navigation-selected': { backgroundColor: colors.background, color: colors.navigationTextActive },
});

export const buttonInteractiveStyles = stylex.create({
  'outline': {
    backgroundColor: {
      'default': colors.background,
      ':hover': colors.surfaceHover,
      ':focus': colors.surfacePressed,
      ':active': colors.surfacePressed,
    },
    borderColor: { 'default': colors.border, ':focus': colors.accent, ':active': colors.accent },
  },
  'theme': {
    backgroundColor: {
      'default': colors.accent,
      ':hover': colors.accentHover,
      ':focus': colors.accentPressed,
      ':active': colors.accentPressed,
    },
    borderColor: {
      'default': colors.accent,
      ':hover': colors.accentHover,
      ':focus': colors.accentPressed,
      ':active': colors.accentPressed,
    },
  },
  'theme-light': {
    backgroundColor: {
      'default': colors.icon,
      ':hover': colors.link,
      ':focus': colors.accentPressed,
      ':active': colors.accentPressed,
    },
    borderColor: {
      'default': colors.icon,
      ':hover': colors.link,
      ':focus': colors.accentPressed,
      ':active': colors.accentPressed,
    },
  },
  'danger': {
    backgroundColor: {
      'default': colors.borderInvalid,
      ':hover': colors.dangerHover,
      ':focus': colors.dangerHover,
      ':active': colors.borderInvalid,
    },
    borderColor: {
      'default': colors.borderInvalid,
      ':hover': colors.dangerHover,
      ':focus': colors.dangerHover,
      ':active': colors.borderInvalid,
    },
  },
  'warning': {
    backgroundColor: {
      'default': colors.warning,
      ':hover': colors.warningHover,
      ':focus': colors.warningHover,
      ':active': colors.warning,
    },
    borderColor: {
      'default': colors.warning,
      ':hover': colors.warningHover,
      ':focus': colors.warningHover,
      ':active': colors.warning,
    },
  },
  'no-border': {
    backgroundColor: {
      'default': 'transparent',
      ':hover': colors.surfaceHover,
      ':focus': colors.surfaceHover,
      ':active': colors.surfaceHover,
    },
  },
  'navigation': {
    backgroundColor: {
      'default': 'transparent',
      ':hover': colors.background,
      ':focus': colors.background,
      ':active': colors.background,
    },
  },
  'navigation-selected': {
    backgroundColor: {
      'default': colors.background,
      ':hover': colors.background,
      ':focus': colors.background,
      ':active': colors.background,
    },
  },
});
